import React, { Component } from "react";
import { connect } from "react-redux";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

import {
  getDaysForRotationWisePackage,
  getUserData,
  axiosInstnace as Axios,
  getDaysForDaysPackage,
} from "../../util/util";
import { endPoints } from "../../config";
import NoPackage from "./NoPackage";

class CustomisePackageComp extends Component {
  slotData;
  constructor(props) {
    super(props);
    //Set initial state
    this.state = {
      totalDays: 3,
      fctPerDay: null,
      totalfctPerDay: null,
      rotationPerDay: 1,
      audioDuration: 10,
      totalSecondages: 1,
      multiStatetotalSecondages: 1,
      discountPercent: 0,
      multidiscountPercent: 0,
      discountCost: 0,
      totalCost: 0,
      multidiscountCost: 0,
      multitotalCost: 0,
      station: "",
      minValue: "",
      MinimumAmountMet: true,
      MultiMinimumAmountMet: true,
      addStationView: false,
      stationwisedetails: {},
      stationslist: props.stations,
    };
  }
  

  calculateMinAmount(rodp, days = 3, audio = 10) {
    let { discountPercent, minValue } = this.state;
    minValue = minValue ? minValue : 0;
    let rotation =
      minValue == 0
        ? 1
        : minValue /
          (rodp * days * audio - rodp * days * audio * (discountPercent / 100));
    if (this.state.rotationPerDay && this.state.rotationPerDay == 1) {
      this.setState({ rotationPerDay: Math.round(rotation) });
    }
  }

  //Fetching rodp data
  componentWillReceiveProps = (nextProp) => {
    // let { rodp } = this.props;
    if (
      nextProp.station !== this.props.station ||
      nextProp.stations !== this.props.stations
    ) {
      this.updatePackages(nextProp);
    }
  };
  updatePackages = async (nextProp) => {
    let rodpRate = 0,
      minValue = 0;
    let { rodp, station, stations } = nextProp;
    await this.setState({
      stationslist: stations,
    });
    ;
    if (station && stations.length === 0) {
      await this.setState({
        stationwisedetails: {},
      });
      let response = await Axios.get(`${endPoints.getMinimumValue}`, {
        params: { station },
      });
      this.setState({ minValue: response.data.data.data.minValue });
      this.calculateMinAmount(response.data.data.data.rodpRate / 10);
    }
    let stationwisedetails = {};
    if (stations.length > 0) {
      for (const station1 of stations) {
        let response = await Axios.get(`${endPoints.getMinimumValue}`, {
          params: { station: station1 },
        });
        let output = response.data.data.data;
        rodpRate = rodpRate + Number(output.rodpRate);
        minValue = minValue + output.minValue ? Number(output.minValue) : 0;
        stationwisedetails[station1] = output.rodpRate / 10;
      }
      rodpRate = rodpRate / stations.length;
      minValue = (minValue / stations.length).toFixed(0);
      console.log(rodpRate, "calculated rodp");
      console.log(minValue, "calculated minValue");
      console.log(stationwisedetails, "calculated station details");
      let {
        totalSecondages,
        rotationPerDay,
        audioDuration,
        discountPercent,
        totalDays,
      } = this.state;
      this.props.handleMultiStateDetails({
        totalSecondages,
        rotationPerDay,
        audioDuration,
        discountPercent,
        totalDays,
      });
      debugger
      this.setState([stationwisedetails]);
      this.props.handlestationwisedetails(stationwisedetails);
      this.calculateMinAmount(rodpRate / 10);
    }
    //console.log('rodp===>>', rodp, nextProp.rodp)
    await this.setState({
      rodp: stations.length > 0 ? rodpRate / 10 : rodp / 10,
      station: station,
    });

    let totalDays = 3;
    this.handleTotalSeconds();
    // let discountPercent = getDaysForRotationWisePackage(totalDays);
    let { rotationPerDay, audioDuration } = this.state;
    let fctPerDay = rotationPerDay * audioDuration;
    await this.handlePercent(totalDays, fctPerDay);
    await this.handleTotalDiscount();
    await this.handleTotalCost();
  };

  handlePercent = async (totalDays, fctPerDay) => {
    let discountPercent = getDaysForDaysPackage(totalDays);
    const response = await Axios.get(
      `${endPoints.getCustomPackage}?secondages=${totalDays * fctPerDay}`
    );
    if (response && response.data.statusCode === 200) {
      let { data } = response.data.data;
      // handleCost(data[0], days);
      console.log(data);
      discountPercent = data[0] ? data[0].discount : discountPercent;
      //console.log('To get Discount percent', data);
      //console.log('To get Discount percent', totalDays);
    }
    let multidiscountPercent = getDaysForDaysPackage(totalDays);
    const response1 = await Axios.get(
      `${endPoints.getCustomPackage}?secondages=${this.state.multiStatetotalSecondages}`
    );
    if (response1 && response1.data.statusCode === 200) {
      let { data } = response1.data.data;
      // handleCost(data[0], days);
      console.log(data);
      multidiscountPercent = data[0] ? data[0].discount : multidiscountPercent;
      //console.log('To get Discount percent', data);
      //console.log('To get Discount percent', totalDays);
    }
    this.setState({
      discountPercent,
      multidiscountPercent: multidiscountPercent,
    });
  };

  //Handle total seconds after selecting the rotation
  handleTotalSeconds = () => {
    let { rotationPerDay, audioDuration, totalDays } = this.state;
    ;
    let totalSecondages = rotationPerDay * audioDuration * totalDays;
    this.setState({ totalSecondages });
    ;
    if (this.state.stationslist.length > 0) {
      this.setState({
        multiStatetotalSecondages: totalSecondages * this.props.stations.length,
      });
    }
  };

  //Handle total cost after selecting the rotation
  handleTotalCost = () => {
    let { rodp } = this.state;
    let {
      totalDays,
      rotationPerDay,
      audioDuration,
      discountCost,
      discountPercent,
      multidiscountPercent,
      totalSecondages
    } = this.state;
    let fctPerDay = rotationPerDay * audioDuration;
    let totalCost = Math.round(fctPerDay * rodp * totalDays - discountCost);
    let multitotalCost, totalfctPerDay;
    if (this.state.stationslist.length > 0) {
      totalfctPerDay = fctPerDay * this.state.stationslist.length;
      multitotalCost =
        Math.round(totalfctPerDay * rodp * totalDays) -
        Math.round(totalfctPerDay * rodp * totalDays * multidiscountPercent) /
          100;
    }
    //console.log('totalcost===/////', totalCost);
    this.setState({
      totalCost,
      fctPerDay,
      multitotalCost,
      totalfctPerDay,
      multidiscountCost:
        Math.round(totalfctPerDay * rodp * totalDays * multidiscountPercent) /
        100,
    });
    if (
      this.state.multitotalCost
        ? this.state.multitotalCost < this.state.minValue
        : this.state.totalCost < this.state.minValue
    ) {
      this.setState({
        MinimumAmountMet: false,
      });
    } else {
      this.setState({
        MinimumAmountMet: true,
      });
    }
    this.props.handleMultiStateDetails({
      totalSecondages,
      rotationPerDay,
      audioDuration,
      discountPercent,
      totalDays,
    });
  };

  //Handle total discount after selecting the rotation
  handleTotalDiscount = async () => {
    let { rodp } = this.state;
    let { totalDays, rotationPerDay, audioDuration } = this.state;
    let fctPerDay = rotationPerDay * audioDuration;
    let discountCost = 0;
    await this.handlePercent(totalDays, fctPerDay);
    let { discountPercent } = this.state;
    // let cuzDiscountPercent = discountPercent/2;
    // let cuzDiscountPercentPerRot = cuzDiscountPercent/30;
    // let discountPerRotation = cuzDiscountPercentPerRot * rotationPerDay;
    // let resultDiscount = cuzDiscountPercent + discountPerRotation;
    discountCost = (
      (discountPercent * (fctPerDay * rodp * totalDays)) /
      100
    ).toFixed(2);
    //console.log('Discount cost', resultDiscount);
    //console.log('Discount cost', cuzDiscountPercentPerRot+ ' - '+cuzDiscountPercent);
    // this.setState({ discountCost, fctPerDay, discountPercent: Math.round(resultDiscount)});
    this.setState({ discountCost, fctPerDay, discountPercent });
  };

  //Handle total days after selecting the rotation
  handledaysComplete = async () => {
    let totalDays = getDaysForDaysPackage(this.state.totalDays);
    this.handleTotalSeconds();
    // let discountPercent = getDaysForRotationWisePackage(totalDays);
    let discountPercent = getDaysForDaysPackage(totalDays);
    let { fctPerDay } = this.state;
    //console.log('Total Days - ', totalDays);
    let { rotationPerDay, audioDuration } = this.state;
    fctPerDay = rotationPerDay * audioDuration;
    await this.handlePercent(totalDays, fctPerDay);
    await this.handleTotalDiscount();
    await this.handleTotalCost();
  };

  getPackage = async (days) => {
    const response = await Axios.get(`${endPoints.getDaypakage}?days=${days}`);
    if (response && response.data.statusCode === 200) {
      let { data } = response.data.data;
      // handleCost(data[0], days);
      //console.log('Data - ', data);
    }
  };

  handleDays = (totalDays) => {
    this.setState({ totalDays });
  };

  //Handle Rotaion after selecting the rotation
  handleRotationPerDayComplete = async () => {
    await this.handleTotalSeconds();
    await this.handleTotalDiscount();
    await this.handleTotalCost();
  };

  handleRotationPerDay = (rotationPerDay) => {
    this.setState({ rotationPerDay });
  };

  //Handle Duration after selecting the rotation
  handleDurationComplete = async () => {
    await this.handleTotalSeconds();
    await this.handleTotalDiscount();
    await this.handleTotalCost();
  };

  handleDuration = (audioDuration) => {
    this.setState({ audioDuration });
    // this.handleDurationComplete()
  };
  async componentDidUpdate(prevProps, prevState) {
    console.log(prevState.totalDays, "wheareas ", this.state.totalDays);
    if (prevState.totalDays !== this.state.totalDays) {
      this.handledaysComplete();
    }
    if (
      this.state.rotationPerDay !== prevState.rotationPerDay ||
      this.state.audioDuration !== prevState.audioDuration
    ) {
      this.handleDurationComplete();
    }
    // await this.handledaysComplete()
    // await this.handleDurationComplete()
  }

  // React Life Cycle
  componentDidMount() {
    this.slotData = JSON.parse(localStorage.getItem("slots"));
    if (localStorage.getItem("slots")) {
      this.setState({
        totalDays: this.slotData.totalDays,
        fctPerDay: null,
        rotationPerDay: this.slotData.rotationPerDay,
        audioDuration: this.slotData.audioDuration,
        totalSecondages: 1,
        discountPercent: 0,
        discountCost: 0,
        totalCost: 0,
      });
    } else {
      this.setState({
        totalDays: 3,
        fctPerDay: null,
        rotationPerDay: 1,
        audioDuration: 10,
        totalSecondages: 1,
        discountPercent: 0,
        discountCost: 0,
        totalCost: 0,
      });
    }
  }

  //Choose a package
  choosepackage = () => {
    let {
      fctPerDay,
      totalDays,
      totalSecondages,
      totalCost,
      discountCost,
      discountPercent,
      rotationPerDay,
      audioDuration,
      multiStatetotalSecondages,
      multitotalCost,
      multidiscountCost,
      multidiscountPercent,
      totalfctPerDay,
      stationwisedetails,
    } = this.state;
    debugger
    let finalCost =
      this.props.stationview == "single"
        ? parseInt(totalCost) + parseInt(discountCost)
        : multitotalCost+ multidiscountCost;
    let costWithGst =
      this.props.stationview == "single"
        ? totalCost + (totalCost * 18) / 100
        : multitotalCost + (multitotalCost * 18) / 100;
    const data = {
      fctPerDay:
        this.props.stationview == "single" ? fctPerDay : totalfctPerDay,
      days: totalDays,
      secondages:
        this.props.stationview == "single"
          ? totalSecondages
          : multiStatetotalSecondages,
      rotationPerDay,
      audioDuration,
      discount:
        this.props.stationview == "single"
          ? discountPercent
          : multidiscountPercent,
      discountedCost:
        this.props.stationview == "single"
          ? discountCost
          : multidiscountPercent,
      totalCost: finalCost,
      station: this.props.station,
      rodp: this.state.rodp * 10,
      customrodp: this.props.customRodp ? this.props.customRodp : 10,
      startTime: this.props.startTime,
      endTime: this.props.endTime,
      type: "Rotation Based",
      minValue: this.state.minValue,
      stations: this.props.stations,
      stationwisedetails: this.props.stationwisedetails,
    };
    debugger
    this.props.choosePackage(data);
    localStorage.setItem("slots", JSON.stringify(this.state));
  };

  render() {
    let {
      totalDays,
      totalSecondages,
      rotationPerDay,
      audioDuration,
      totalCost,
      discountCost,
      discountPercent,
      multiStatetotalSecondages,
      multidiscountPercent,
      multidiscountCost,
      multitotalCost,
      stationwisedetails,
    } = this.state;
    let inDivStations = Object.keys(stationwisedetails);
    //console.log('totalcost', totalCost)
    return (
      <div className="days_planning">
        {this.props.stationview && this.props.stationview !== "multi" && (
          <h2>Grow Your Brand With Customized Plans !</h2>
        )}
        <div className="watermark">
          <img src="../../assets/images/logo_watermark.png" />
        </div>

        <div className="rangebar_wrapper brand_rangeslider">
          <div className="wrapper_brandrange">
            <div className="slidecontainer brand_slider">
              <Slider
                value={totalDays}
                orientation="horizontal"
                min={1}
                max={90}
                labels={{ 1: "1", 90: "90" }}
                step={1}
                onChange={this.handleDays}
              />
              <div className="rangeslider_label">Number of Days</div>
            </div>
            <div className="slidecontainer brand_slider">
              <Slider
                value={rotationPerDay}
                orientation="horizontal"
                min={1}
                max={60}
                labels={{ 1: "1", 60: "60" }}
                step={1}
                onChange={this.handleRotationPerDay}
              />
              <div className="rangeslider_label">Rotations Per Day</div>
            </div>
            <div className="slidecontainer brand_slider">
              <Slider
                value={audioDuration}
                orientation="horizontal"
                min={10}
                max={60}
                labels={{
                  10: "10",
                  20: "20",
                  30: "30",
                  40: "40",
                  50: "50",
                  60: "60",
                }}
                step={5}
                onChange={this.handleDuration}
              />
              <div className="rangeslider_label">Spot Duration</div>
            </div>
          </div>
          {this.props.showPackage && this.props.stations.length == 0 && (
            <div className="package_card_wrapper brand_card">
              <div className="package_card_inner">
                <div className="package_card_head">
                  {totalDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  {totalDays === 1 ? "DAY" : "DAYS"}
                </div>
                <div>
                  <ul className="package_card_list">
                    <li>
                      <span className="pack_numb">
                        {totalSecondages
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>{" "}
                      Total Seconds
                    </li>
                    <li>
                      <span className="pack_numb">
                        {rotationPerDay
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>{" "}
                      Rotations Per Day
                    </li>
                    <li>
                      <span className="pack_numb">
                        {audioDuration
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>{" "}
                      Sec Spot Duration
                    </li>
                    {discountPercent > 0 && (
                      <li>
                        <span className="pack_numb">
                          {discountCost
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </span>{" "}
                        Total Savings
                      </li>
                    )}
                  </ul>

                  <span className="package_card_total">
                    {totalCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                    INR
                  </span>
                  {this.state.MinimumAmountMet &&
                    this.props.stationview == "single" && (
                      <div className="choose_plan">
                        <button onClick={this.choosepackage}>
                          CHOOSE PLAN
                        </button>
                      </div>
                    )}
                  {this.props.stationview &&
                    this.props.stationview == "multi" && (
                      <div className="choose_plan">
                        Please add the Stations to choose the plan
                      </div>
                    )}
                  {!this.state.MinimumAmountMet && (
                    <div className="choose_plan">
                      Minimum Amount to create a Campaign in this region is{" "}
                      {this.state.minValue}{" "}
                    </div>
                  )}
                  {discountPercent > 0 && (
                    <div className="package-card-footer">{`You’ve Got ${discountPercent}% Discount`}</div>
                  )}
                </div>
              </div>
            </div>
          )}
          {!this.props.showPackage && <NoPackage />}

          {this.state.stationslist.length > 0 && (
            <div className="package_card_wrapper brand_card" id="multiStateCard">
              <div className="package_card_inner">
                <div className="package_card_head">
                  {totalDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  DAYS
                </div>
                <div>
                  <ul className="package_card_list">
                    <li>
                      <span className="pack_numb">
                        {multiStatetotalSecondages
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>{" "}
                      Total Seconds
                    </li>
                    <li>
                      <span className="pack_numb">
                        {rotationPerDay
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>{" "}
                      Rotations Per Day
                    </li>
                    <li>
                      <span className="pack_numb">
                        {audioDuration
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>{" "}
                      Sec Spot Duration
                    </li>
                    {discountPercent > 0 && (
                      <li>
                        <span className="pack_numb">
                          {multidiscountCost
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </span>{" "}
                        Total Savings
                      </li>
                    )}
                  </ul>

                  <span className="package_card_total">
                    {multitotalCost} INR
                  </span>
                  {this.props.stationview == "multi" &&
                    this.state.MinimumAmountMet && (
                      <div className="choose_plan">
                        <button onClick={this.choosepackage}>
                          CHOOSE PLAN
                        </button>
                      </div>
                    )}
                  {!this.state.MinimumAmountMet && (
                    <div className="choose_plan">
                      Minimum Amount to create a Campaign in this region is{" "}
                      {this.state.minValue}{" "}
                    </div>
                  )}

                  {multidiscountPercent > 0 && (
                    <div className="package-card-footer">{`You’ve Got ${multidiscountPercent}% Discount`}</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateCompainAudio: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};

export default connect(null, mapDispatchToProps)(CustomisePackageComp);



// WEBPACK FOOTER //
// ./web/components/package/RotationPackage.jsx